import { immer } from 'zustand/middleware/immer';
import { createWithEqualityFn } from 'zustand/traditional';

// 스토어의 상태(State) 부분만 따로 정의합니다.
// 액션은 EmoticonFilterStateWithActions에서 정의합니다.
export interface EmoticonFilterState {
  filterType: 'all' | 'crew';
  heartCategory: 'all' | '1-3000' | '3000-5000' | '1-5000' | '5000-10000' | '10000-30000' | '30000-';
  page: number;
  animatedItemIdx: number | null;
  searchType: 'bj' | 'heart';
  searchTypeSelectValue: 'bj' | 'heart';
  bjId: string;
  bjIdx?: number;
  bjIdInputValue: string;
  minHeart: string;
  minHeartInputValue: string;
  maxHeart: string;
  maxHeartInputValue: string;
}

// 상태와 액션을 포함한 전체 스토어 타입
interface EmoticonFilterStateWithActions extends EmoticonFilterState {
  setState: <K extends keyof EmoticonFilterState>(key: K, value: EmoticonFilterState[K]) => void;
  resetFilters: () => void;
}

const initialState: EmoticonFilterState = {
  filterType: 'all',
  heartCategory: 'all',
  page: 1,
  animatedItemIdx: null,
  searchType: 'bj',
  searchTypeSelectValue: 'bj',
  bjId: '',
  bjIdx: undefined,
  bjIdInputValue: '',
  maxHeart: '',
  minHeartInputValue: '',
  minHeart: '',
  maxHeartInputValue: '',
};

export const useEmoticonFilterStore = createWithEqualityFn(
  immer<EmoticonFilterStateWithActions>((set, _get, store) => ({
    ...initialState,
    setState: (key, value) =>
      set((draft) => {
        const state = draft as EmoticonFilterState;
        state[key] = value;
      }),

    resetFilters: () => {
      set(store.getInitialState());
    },
  })),
);
